import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { withStyles } from 'tss-react/mui';

import Card from '../../../Card';
import WalletIcon from '../../../../../../assets/icons/WalletIcon';
import { currencyDefaults, locale } from '../../../../../../utils/intl';
import { customer$ } from '../../../../../../store/profile/selectors';

const StyledIcon = withStyles(WalletIcon, {
  root: {
    fontSize: '4rem',
  },
});

const currency = Intl.NumberFormat(locale, currencyDefaults);

function ConcreteCashDetails() {
  const customer = useSelector(customer$);

  if (!customer?.walletBalance) return null;

  return (
    <Card title="Concrete Cash">
      <Typography variant="h5" component="h2">
        {currency.format(customer.walletBalance ?? 0)}
      </Typography>
      <Typography gutterBottom color="textSecondary">
        available
      </Typography>
      <StyledIcon />
    </Card>
  );
}

export default ConcreteCashDetails;
